import { render, staticRenderFns } from "./SubmitInformationExchange.vue?vue&type=template&id=421d2a30&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./SubmitInformationExchange.vue?vue&type=script&lang=js&"
export * from "./SubmitInformationExchange.vue?vue&type=script&lang=js&"
import style0 from "./SubmitInformationExchange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubmitInformationExchange.vue"
export default component.exports